module.exports = __webpack_public_path__ + "media/assets/images/smart_working/3-2-bb41d26bc717a8998857dfeea724efe0.png";